import { createSelector } from 'reselect';
import get from 'lodash/get';

import { initialState } from './reducer';
import { createSelectFieldOptions } from '../../utils/common';

export const selectCompanyDomain = state => state.Company || initialState;

const selectCompanyData = () =>
  createSelector(selectCompanyDomain, subState => get(subState, 'companyData.entity', {}));

const selectCompanyProductions = () => createSelector(selectCompanyDomain, subState => get(subState, 'productions'));
const selectCompanyPerformances = () =>
  createSelector(selectCompanyDomain, subState => {
    const performances = get(subState, 'performances');
    performances.data.forEach(performance => {
      performance.companies = [performance.company];
      performance.venues = [performance.venue];
      return performance;
    });
    return performances;
  });

const selectCompanyProductionsLoading = () =>
  createSelector(selectCompanyDomain, subState => get(subState, 'productions.loading', false));
const selectCompanyPerformancesLoading = () =>
  createSelector(selectCompanyDomain, subState => get(subState, 'performances.loading', false));

const selectCompanyEditProductions = () =>
  createSelector(selectCompanyDomain, subState => get(subState, 'editSeasonProductions'));

const selectCompanyContacts = () => createSelector(selectCompanyDomain, subState => get(subState, 'contacts.data', []));

const selectCompanyUnpublishedProductions = () =>
  createSelector(selectCompanyDomain, subState => get(subState, 'unpublishedProductions'));

const selectCompanyVenues = () => createSelector(selectCompanyDomain, subState => get(subState, 'venues.data', []));

const selectCompanyEditVenues = () =>
  createSelector(selectCompanyDomain, subState => {
    const company = get(subState, 'companyData.entity', {});
    const venues = get(subState, 'venues.data', []).map(v => ({
      ...v,
      isDefault: v.companies?.find(c => c?.id === company.id)?.isDefault,
    }));
    return { loading: get(subState, 'venues.loading', []), data: venues };
  });

const selectCompanyUpdatedProductions = () =>
  createSelector(selectCompanyDomain, subState => get(subState, 'updatedProductions', {}));

const selectCompanySeasonsOptions = () =>
  createSelector(selectCompanyDomain, subState =>
    createSelectFieldOptions(get(subState, 'seasons.data', []), 'id', 'name'),
  );

const selectCompanyLoading = () =>
  createSelector(selectCompanyDomain, subState => get(subState, 'companyData.loading', false));

const selectCompanyMusicalWorksList = () =>
  createSelector(selectCompanyDomain, subState => ({
    loading: get(subState, 'musicalWorksList.loading', false),
    options: createSelectFieldOptions(get(subState, 'musicalWorksList.data', false), 'id', 'name'),
  }));
const selectCompanyImages = () => createSelector(selectCompanyDomain, subState => get(subState, 'images', {}));

const selectCompanyVideos = () => createSelector(selectCompanyDomain, subState => get(subState, 'videos', {}));

const selectStaff = () => createSelector(selectCompanyDomain, subState => get(subState, 'staff', []));

const selectStaffUpdating = () => createSelector(selectCompanyDomain, subState => get(subState, 'isStaffUpdating', []));

const selectLanguages = () => createSelector(selectCompanyDomain, subState => get(subState, 'languages.data', false));

const selectCompanyDescriptions = () =>
  createSelector(selectCompanyDomain, subState => get(subState, 'descriptions', false));

export {
  selectCompanyData,
  selectCompanyProductions,
  selectCompanyContacts,
  selectCompanySeasonsOptions,
  selectCompanyVenues,
  selectCompanyUpdatedProductions,
  selectCompanyUnpublishedProductions,
  selectCompanyLoading,
  selectCompanyMusicalWorksList,
  selectCompanyEditProductions,
  selectCompanyImages,
  selectCompanyVideos,
  selectStaff,
  selectLanguages,
  selectCompanyDescriptions,
  selectCompanyPerformances,
  selectCompanyPerformancesLoading,
  selectCompanyProductionsLoading,
  selectCompanyEditVenues,
  selectStaffUpdating,
};
